import { ProtectedPage } from "./ProtectedPage";

export default ProtectedPage;
